module.exports = __webpack_public_path__ + "static/media/logo.64494b99.svg";